import React, { FC } from 'react';
import FormBuilder from 'containers/common/sections/thank-you/FormBuilder';
import { DocumentDeclined } from 'assets/images/document-declined';
import useI18n from "evcharging/hooks/useI18n";

const DocumentDeclinedPage: FC = () => {
  const { t } = useI18n();

  return (
    <FormBuilder
      image={DocumentDeclined}
      title={t('document-declined.title')}
      listItems={[t('document-declined.description')]}
      reverse
    />
  );
};

export default DocumentDeclinedPage;
